import { useQuery } from '@apollo/client'
import { Box } from '@factorialco/deprecated-design-system'
import { AtsProcessesPageDocument } from 'generated/resources/graphql'

import { useAtsContext } from 'modules/ats/lib/atsContext'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { HiringPipelinesSettings } from './sections/HiringPipelinesSettings'
import { JoinPromotionSettings } from './sections/JoinPromotionSettings'
import { RequisitionsSettings } from './sections/RequisitionsSettings'

const ProcessesPage = () => {
  const { canManageAtsSettings } = useAtsContext()
  const { loading, data } = useQuery(AtsProcessesPageDocument, {
    skip: !canManageAtsSettings,
  })
  const requisitionsEnabled =
    data?.companies.featureAvailabilitiesConnection.nodes.at(0)?.available || false
  const canManageRequisitions = data?.ats._policies.requisitionsManage.can || false

  return (
    <ResponsivePage.Body
      loading={loading}
      error={null}
      authorized={canManageAtsSettings}
      showHeader={false}
    >
      <Box gap="s48">
        <HiringPipelinesSettings />
        <JoinPromotionSettings />

        {requisitionsEnabled && canManageRequisitions && <RequisitionsSettings />}
      </Box>
    </ResponsivePage.Body>
  )
}

export default ProcessesPage
